// Base
import { DetailedHTMLProps, InputHTMLAttributes } from 'react'

// Components
import { Box, Flex } from 'yard-utilities/components'

// Styles
import styles from './Input.module.sass'

interface InputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  label?: string
}

const Input = ({ startIcon, endIcon, label, ...rest }: InputProps) => {
  const { style, name, id, className, disabled, ...restProps } = rest

  return (
    <div>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <Box
        backgroundColor="white"
        borderRadius={{ sm: [8] }}
        border="grey-4"
        padding={{ sm: [0, 16] }}
        className={`${styles.inputGroup} ${className} ${
          disabled ? styles.disabled : ''
        }`}
        style={style}
      >
        <Flex
          alignItems="center"
          columnGap={{ sm: 8 }}
          className={styles.inputGroupInner}
        >
          {startIcon && <div className={styles.startIcon}>{startIcon}</div>}
          <input name={name} id={id} disabled={disabled} {...restProps} />
          {endIcon && <div className={styles.endIcon}>{endIcon}</div>}
        </Flex>
      </Box>
    </div>
  )
}

export { Input }
